import { useState } from 'react';
import { Modal } from '@sokcho-girls/common';
import './PrivacyPolicyButton.scss';

interface PrivacyPolicy {
    id: number;
    content: string;
    effectiveDate: string;
    createdAt: string;
}

interface PrivacyPolicyButtonProps {
    className?: string;
}

export function PrivacyPolicyButton({ className = 'privacy-policy-footer-btn' }: PrivacyPolicyButtonProps) {
    const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
    const [isPrivacyPolicyLoading, setIsPrivacyPolicyLoading] = useState(false);
    const [privacyPolicy, setPrivacyPolicy] = useState<PrivacyPolicy | null>(null);
    const [privacyPolicyError, setPrivacyPolicyError] = useState<string | null>(null);

    const fetchPrivacyPolicy = async () => {
        setIsPrivacyPolicyLoading(true);
        setPrivacyPolicyError(null);

        try {
            const response = await fetch('/api/center/privacy-policy/current', {
                credentials: 'include',
            });

            if (response.status === 204) {
                setPrivacyPolicy(null);
                return;
            }

            if (!response.ok) {
                throw new Error('개인정보 처리 방침을 불러오지 못했습니다.');
            }

            const data: PrivacyPolicy = await response.json();
            setPrivacyPolicy(data);
        } catch (error) {
            console.error('Failed to fetch privacy policy:', error);
            setPrivacyPolicy(null);
            setPrivacyPolicyError('개인정보 처리 방침을 불러오지 못했습니다.');
        } finally {
            setIsPrivacyPolicyLoading(false);
        }
    };

    const handleOpenPrivacyPolicy = () => {
        setIsPrivacyPolicyOpen(true);
        void fetchPrivacyPolicy();
    };

    return (
        <>
            <button type="button" className={className} onClick={handleOpenPrivacyPolicy}>
                개인정보 처리 방침
            </button>

            <Modal
                isOpen={isPrivacyPolicyOpen}
                onClose={() => setIsPrivacyPolicyOpen(false)}
                title="개인정보 처리 방침"
                size="lg"
                overlayClassName="privacy-policy-modal-overlay"
                modalClassName="privacy-policy-modal-shell"
                contentClassName="privacy-policy-modal-shell__content"
            >
                <div className="privacy-policy-modal">
                    {isPrivacyPolicyLoading ? (
                        <p className="privacy-policy-modal__message">불러오는 중입니다.</p>
                    ) : privacyPolicyError ? (
                        <p className="privacy-policy-modal__message">{privacyPolicyError}</p>
                    ) : privacyPolicy ? (
                        <>
                            <div className="privacy-policy-modal__meta">
                                시행일 {privacyPolicy.effectiveDate}
                            </div>
                            <pre className="privacy-policy-modal__content">{privacyPolicy.content}</pre>
                        </>
                    ) : (
                        <p className="privacy-policy-modal__message">현재 등록된 개인정보 처리 방침이 없습니다.</p>
                    )}
                </div>
            </Modal>
        </>
    );
}
